import { render, staticRenderFns } from "./ShipmentScript.vue?vue&type=template&id=27c71b48&"
import script from "./ShipmentScript.vue?vue&type=script&lang=js&"
export * from "./ShipmentScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports